export type StaticPage = {
    id: string;
    staticPageId: string;
    title: string;
    slug: string;
    content: string;
    createdAt: string;
    updatedAt: string;
};

export type StaticPageDraft = {
    title: string;
    slug: string;
    content: string;
};

export function createEmptyStaticPageDraft(): StaticPageDraft {
    return {
        title: '',
        slug: '',
        content: '',
    };
}

export function createStaticPageDraft(staticPage: StaticPage): StaticPageDraft {
    return {
        title: staticPage.title,
        slug: staticPage.slug,
        content: staticPage.content,
    };
}